module.exports = __webpack_public_path__ + "static/img/shangchuanchangjingtu.3d18979.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/shangchuanchangjingtu.png
// module id = qCS3
// module chunks = 24